// src/axios/apiCall.js
import axios from "axios";
import { BACKEND_URL, CATALOGO_MENSAJES } from "../shared/constants";
import { CREATE_AUTH_HEADER } from '../shared/functions';

export function apiCall(token, prefix = null) {
  const buildUrl = (controller, method) => `${BACKEND_URL}/${prefix ? `${prefix}/` : ""}${controller ? `${controller}/` : ""}${method}`;

  return {
    // GET
    get: async (controller, method, config = {}) => {
      const URL = buildUrl(controller, method);
      const finalConfig = { ...CREATE_AUTH_HEADER(token), ...config };
      return await axios.get(URL, finalConfig);
    },

    // POST
    post: async (controller, method, data, config = {}) => {
      const URL = buildUrl(controller, method);
      const finalConfig = { ...CREATE_AUTH_HEADER(token), ...config };
      return await axios.post(URL, data, finalConfig);
    },

    // DELETE
    delete: async (controller, method) => {
      const URL = buildUrl(controller, method);
      return await axios.delete(URL, CREATE_AUTH_HEADER(token));
    },

    // PUT
    put: async (controller, method, data) => {
      const URL = buildUrl(controller, method);
      return await axios.put(URL, data, CREATE_AUTH_HEADER(token));
    },

    // PATCH
    patch: async (controller, method, data) => {
      const URL = buildUrl(controller, method);
      return await axios.patch(URL, data, CREATE_AUTH_HEADER(token));
    },

    handleCatch: (error) => {
      const response = { success: false };
      if (!error.response || (error.response.status === 404 && !error.response.data.detail)) {
        response.message = CATALOGO_MENSAJES.error404;
      }
      else if (error.response.status === 500) {
        if (error.response.data.detail)
          response.message = error.response.data.detail;
      } else if (error.response.status === 400) {
        if (error.response.data.detail)
          response.message = error.response.data.detail;
      } else if (error.response.status >= 400) {
        let message = '';
        if (Array.isArray(error.response.data.detail)) {
          const detail = error.response.data.detail[0];
          if (detail) {
            message = (detail.msg || '') + ": " + (detail.loc ? detail.loc[1] : '');
          } else {
            message = 'Detalles no disponibles';
          }
        } else if (typeof error.response.data.detail === 'string') {
          message = error.response.data.detail;
        }
        response.message = message;
      } else {
        response.message = CATALOGO_MENSAJES.error404;
      }
      return response;
    },

    handleCatchBlob: async (error) => {
      const response = { success: false };

      if (!error.response || error.response.status === 404) {
        if (error.response && error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const responseParsed = JSON.parse(text);
            response.message = responseParsed.message || responseParsed.detail || CATALOGO_MENSAJES.error404;
          } catch (e) {
            response.message = CATALOGO_MENSAJES.error404;
          }
        } else {
          response.message = CATALOGO_MENSAJES.error404;
        }
      } else if (error.response && error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const responseParsed = JSON.parse(text);
          response.message = responseParsed.detail || responseParsed.message || 'Error del servidor';
        } catch (parseError) {
          response.message = 'Error del servidor';
        }
      } else if (error.response && error.response.data) {
        if (typeof error.response.data === 'string') {
          try {
            const responseParsed = JSON.parse(error.response.data);
            response.message = responseParsed.detail || responseParsed.message;
          } catch (e) {
            response.message = error.response.data;
          }
        } else if (typeof error.response.data === 'object') {
          response.message = error.response.data.detail || error.response.data.message;
        }
      } else {
        response.message = 'Error de conexión';
      }

      return response;
    },

    handleCatchWithDetails: (error) => {
      const response = { sucess: false }; // Mantengo el typo como en tu código original
      if (!error.response || error.response.status === 404)
        response.message = CATALOGO_MENSAJES.error404;
      else if (error.response.status === 500) {
        if (error.response.data.detail)
          response.message = error.response.data.detail;
      } else if (error.response.status === 400) {
        if (error.response.data.detail) {
          response.message = error.response.data.detail;
        } else if (error.response.data.error) {
          response.message = error.response.data.error.message;
          response.details = error.response.data.error.details;
        }
      }
      return response;
    },

    handleCatchMultiData: (error) => {
      const response = { sucess: false }; // Mantengo el typo como en tu código original
      if (!error.response || error.response.status === 404)
        response.message = CATALOGO_MENSAJES.error404;
      else if (error.response.status === 500) {
        if (error.response.data.detail)
          response.message = error.response.data.detail;
      } else if (error.response.status === 400) {
        response.message = error.response.data.detail;
        response.data = error.response.data.data;
      }
      return response;
    }
  };
}
